import RichTextView from '@/components/actricle/RichTextView.vue'
import AutoLoopImageView from '@/components/actricle/AutoLoopImageView.vue'
import CoverflowImageView from '@/components/actricle/CoverflowImageView.vue'
import ServiceFeatureView from '@/components/actricle/ServiceFeatureView.vue'
import CaseView from '@/components/actricle/CaseView.vue'
import ServiceContentView from '@/components/actricle/ServiceContentView.vue'
import ModelTable from '@/components/actricle/ModelTable.vue'
import MultiRichTextView from "@/components/actricle/MultiRichTextView.vue";

export function registerGlobalComponents(app) {
	const components = [
		RichTextView,  // 富文本
		AutoLoopImageView,  // 自动轮播
		CoverflowImageView, // 轮播图
		ServiceFeatureView, // 服务特性
		CaseView, // 案例
		ServiceContentView, // 服务内容
		ModelTable, // 模型表格
		MultiRichTextView // 多层富文本
	]
	components.forEach(Component => {
		app.component(Component.name, Component)
	})
}